import { useMutation } from '@apollo/client';
import { APPROVE_FITUP } from '@bechtel/client-gql';
import { ApproveFitupPayload, MilestoneStatusInput } from '@bechtel/types';

export function useApproveFitup(
  onCompleted: (data) => void,
  onError: (error) => void,
  refetchQueries: string[]
): //@ts-ignore type changed in @apollo/client
MutationTuple<{ approveFitup: ApproveFitupPayload }, { input: MilestoneStatusInput }> {
  const response = useMutation<{ approveFitup: ApproveFitupPayload }, { input: MilestoneStatusInput }>(APPROVE_FITUP, {
    notifyOnNetworkStatusChange: true,
    onCompleted: (data) => {
      if (onCompleted) onCompleted(data);
    },
    onError: (error) => {
      if (onError) onError(error);
    },
    refetchQueries: refetchQueries,
  });
  return response;
}
